import merge from "lodash-es/merge"

import { exists } from "shared/lib/exists"
import { RJSFFormData, RJSFSchema } from "shared/types/RJSF"

const childArrayPropertyNames = ["anyOf", "allOf"] as const

function getFieldDefault(schema: RJSFSchema) {
  if (exists(schema.default)) {
    return schema.default
  }

  return null
}

export function getDefaultFormData(
  schema: RJSFSchema | null | undefined
): RJSFFormData | null {
  const childArrayPropertyName = childArrayPropertyNames.find(
    propName => schema?.[propName]
  )

  if (schema?.oneOf) {
    if (!schema.oneOf[0]) {
      throw new Error("RJSFSchema Property oneOf cannot be empty!")
    }
    if (!exists(schema.defaultIndex)) {
      return getDefaultFormData(schema.oneOf[0])
    }
    if (schema.defaultIndex >= schema.oneOf.length) {
      throw new Error("Default schema index out of range!")
    }
    return getDefaultFormData(schema?.oneOf[schema.defaultIndex])
  }

  if (schema && childArrayPropertyName && schema[childArrayPropertyName]) {
    return merge(
      {},
      ...(schema[childArrayPropertyName] as RJSFSchema[]).map(subSchema =>
        getDefaultFormData({ ...subSchema, type: "object" })
      )
    )
  }

  if (!schema || !schema.properties) {
    return null
  }

  return Object.fromEntries(
    Object.entries(schema.properties).map(([key, propertySchema]) => [
      key,
      propertySchema.type === "object" || !propertySchema.type
        ? getDefaultFormData(propertySchema)
        : getFieldDefault(propertySchema)
    ])
  )
}
